module.exports = __webpack_public_path__ + "img/lg_ring_y_e_0_1@2x.d498c40e.png";